/**
 * Generic display-formatting utilities shared across the application.
 */

/**
 * Format a byte count to human-readable format
 *
 * @param bytes - Size in bytes
 * @returns Formatted size string (e.g., "512 B", "12.1 KB", "4.1 MB")
 *
 * @example
 * formatFileSize(512) // "512 B"
 * formatFileSize(12345) // "12.1 KB"
 * formatFileSize(4300000) // "4.1 MB"
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Format a cost in cents as dollars
 *
 * @example
 * formatCost(312) // "$3.12"
 */
export function formatCost(costCents: number): string {
  return `$${(costCents / 100).toFixed(2)}`;
}
